import { toast } from "sonner";
import { trpc } from "@/lib/trpc";

/** Mutations do plano de tratamento, já com a invalidação de tudo que mostra plano. */
export function usePlanoMutations() {
  const utils = trpc.useUtils();
  const atualizar = () => utils.plano.invalidate();
  const erro = (e: { message: string }) => toast.error(e.message);
  return {
    criar: trpc.plano.criar.useMutation({ onSuccess: atualizar, onError: erro }),
    atualizar: trpc.plano.atualizar.useMutation({ onSuccess: atualizar, onError: erro }),
    mudarStatus: trpc.plano.mudarStatus.useMutation({ onSuccess: atualizar, onError: erro }),
    salvarItem: trpc.plano.salvarItem.useMutation({
      onSuccess: (r) => {
        atualizar();
        // O preço foi pro catálogo: listas de procedimentos (Serviços, Agenda) passam a mostrá-lo.
        if (r.guardadoNoCatalogo) {
          utils.service.invalidate();
          toast.success("Preço guardado no procedimento para os próximos planos.");
        }
      },
      onError: erro,
    }),
    removerItem: trpc.plano.removerItem.useMutation({ onSuccess: atualizar, onError: erro }),
    reordenar: trpc.plano.reordenar.useMutation({ onSuccess: atualizar, onError: erro }),
    marcarFeito: trpc.plano.marcarFeito.useMutation({ onSuccess: atualizar, onError: erro }),
    marcarEntregue: trpc.plano.marcarEntregue.useMutation({ onSuccess: atualizar }),
    guardarPreco: trpc.plano.guardarPreco.useMutation({
      onSuccess: () => {
        utils.service.invalidate();
        toast.success("Preço do procedimento atualizado.");
      },
      onError: erro,
    }),
  };
}

export const reais = (cents: number | null | undefined) =>
  cents == null ? "Sem preço" : (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const paraCampo = (cents: number | null | undefined) =>
  cents == null || cents === 0 ? "" : (cents / 100).toFixed(2).replace(".", ",");
